var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row p-0 m-0 mb-5 mt-5"},[_vm._l((_vm.members),function(member){return _c('Member',{key:member._id,attrs:{"member":member}})}),_c('MemberForm')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }